import { FieldErrors, Resolver } from 'react-hook-form';

import applyFlexiLoanFormValidation from './ApplyFlexiLoanFormValidation';
import { TFormData } from './ApplyFlexiLoanFormView';

export const applyFlexiLoanFormResolver: Resolver<TFormData> = (values) => {
    const validationErrors = applyFlexiLoanFormValidation(values);
    const errors: FieldErrors<TFormData> = {};

    for (const [field, message] of Object.entries(validationErrors)) {
        errors[field as keyof TFormData] = {
            type: 'validate',
            message: message as string
        };
    }

    if (Object.keys(errors).length === 0) {
        return { values, errors: {} };
    }

    return { values: {}, errors };
};
